import React, { useContext, useEffect } from "react";
import { Menu, Icon, Dropdown, Popup, Image } from "semantic-ui-react";
import { RootStoreContext } from "../../app/stores/rootStore";
import { Link, useNavigate } from "react-router-dom";
import ChangePasswordForm from "../user/ChangePasswordForm";
import EditUserForm from "../user/EditUserForm";
import { observer } from "mobx-react-lite";
import { Role } from "../../app/util/role";
import PrivacyPolicyModal from "../user/PrivacyPolicyModal";
import { useState } from "react";

const NavBar = () => {
  const navigate = useNavigate();
  const [openPrivacy, setOpenPrivacy] = useState(false);

  //variables para uso la informacion del userStore
  const rootStore = useContext(RootStoreContext);
  const { user, logout } = rootStore.userStore;
  const { openModal } = rootStore.modalStore;
  const { getSupplier, supplier, image } = rootStore.companyStore;

  useEffect(() => {
    getSupplier();
  }, [getSupplier]);

  //variable para el uso del enrutamiento de react-router-dom
  const match = {
    url: '/home',
  };

  return (
    <div style={{ position: "relative" }}>
      <PrivacyPolicyModal open={openPrivacy} onClose={() => setOpenPrivacy(false)} />
      <div className="logoexterno" style={!image ? { top: 0, height: "100%", width: 120, display: "flex", alignItems: "center" } : {}}>
        {image ? (
          <Link to={`${match.url}/Dashboard`}>
            <Image className="imagenexterna" src={image} />
          </Link>
        ) : (
          <a href="https://majim-e.co" target="_blank" rel="noreferrer">
            <Image src="/majimeLogo.png" style={{ width: 120 }} />
          </a>
        )}
      </div>
      <Menu stackable className="nomargintop" >              
        <Menu.Item  onClick={()=>navigate(`${match.url}/Dashboard`)} name="nombreEmpresa" className="supplierName">
          {supplier?.name || supplier?.registrationName || "MajimDev"}
        </Menu.Item>

        <Menu.Menu position="right">
          <Menu.Item name="iconos">
            <Link to={`${match.url}/Dashboard`}>
              <Popup
                basic
                content="Métricas"
                trigger={<Icon className="navbaricon" size="big" color="black" name="area graph" />}
              />
            </Link>
            <Link to={`${match.url}/TrackingDocuments`}>
              <Popup
                basic
                content="Seguimiento Documentos"
                trigger={
                  <Icon
                    className="navbaricon" 
                    size="big"
                    color="black"
                    name="list alternate outline"
                  />
                }
              />
            </Link>
            <Link to={`${match.url}/TrackingPayrolls`}>
              <Popup
                basic
                content="Seguimiento Nómina"
                trigger={
                  <Icon
                    className="navbaricon" 
                    size="big"
                    color="black"
                    name="money bill alternate"
                  />
                }
              />
            </Link>
            {user?.role === Role.Admin && (
              <Link to={`${match.url}/Configuration`}>
                <Popup
                  basic
                  content="Configuración"
                  trigger={
                    <Icon  className="navbaricon" size="big" color="black" name="sun outline" />
                  }
                />
              </Link>
            )}          
            <Dropdown floating basic text={user?.username}>
              <Dropdown.Menu>
                <Dropdown.Item as="h3" disabled>
                  <strong>
                    {user?.name} {user?.lastName}
                  </strong>
                </Dropdown.Item>
                <Dropdown.Divider />
                <Dropdown.Item
                  onClick={() =>
                    openModal(<EditUserForm />, "Editando mi perfil")
                  }
                >
                  Edita tu perfil
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() =>
                    openModal(<ChangePasswordForm />, "Cambia tu contraseña")
                  }
                >
                  Cambia tu contraseña
                </Dropdown.Item>
                <Dropdown.Divider />
                <Dropdown.Item onClick={() => setOpenPrivacy(true)}>
                  Política de Privacidad
                </Dropdown.Item>
                <Dropdown.Item onClick={logout}>Cerrar sesión</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Menu.Item>
        </Menu.Menu>
      </Menu>
    </div>
  );
};
export default observer(NavBar);
